import { getErrorMessageFromAPI } from '@/utilz';
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { getShipmentListInError, getShipmentListInSuccess } from './SaversActions';
import { getShipmentListEffect } from './SaversEffects';
import SaversTypes from './SaversTypes';

function* updateRequestId() {
  yield put({ type: 'SaversTypes.UPDATE_SELECTED_TRAILER_REQUEST', data: '' });
}

function* getShipmentList() {
  const {
    savers: { shipmentFilters },
  } = yield select((state) => state);
  try {
    const { data } = yield call(getShipmentListEffect, shipmentFilters);
    yield put(getShipmentListInSuccess({ data }));
  } catch (e) {
    if (e?.code !== 'ERR_CANCELED') {
      yield put(getShipmentListInError({ message: getErrorMessageFromAPI(e) }));
    }
  }
}

export default function* saversSaga() {
  yield takeLatest(SaversTypes.SET_SELECTED_TRAILER_REQUEST, updateRequestId);
  yield takeEvery(SaversTypes.GET_SHIPMENT_LIST_PROGRESS, getShipmentList);
}
